import { render, staticRenderFns } from "./Restorani.vue?vue&type=template&id=378d1a3e&"
import script from "./Restorani.vue?vue&type=script&lang=js&"
export * from "./Restorani.vue?vue&type=script&lang=js&"
import style0 from "./Restorani.vue?vue&type=style&index=0&id=378d1a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports